import { Modal } from '@affine/component';
import type { DialogComponentProps } from '@affine/core/modules/dialogs';
import type { WORKSPACE_DIALOG_SCHEMA } from '@affine/core/modules/dialogs/constant';
import { useCallback, useState } from 'react';
import { InviteMemberEditor } from './invite-member-editor/invite-member-editor';
import { MemberManagement } from './member-management';


export const FolderPermissionDialog = ({
  close,
  nodeId,
}: DialogComponentProps<WORKSPACE_DIALOG_SCHEMA['folder-permission']>) => {

  const [currentView, setCurrentView] = useState<'invite' | 'member'>('member');

  const onCancel = useCallback(() => {
    close();
  }, [close]);

  return (
    <Modal
      open
      onOpenChange={onCancel}
      withoutCloseButton
      width="480px"
      height="400px"
      contentOptions={{
        style: {
          padding: 8,
          maxWidth: 944,
          backgroundColor: 'var(--affine-background-primary-color)',
        },
      }}
      persistent
    >
      {currentView === 'invite' ? (
        <InviteMemberEditor nodeId={nodeId} onClickCancel={() => setCurrentView('member')} />
      ) : (
        <MemberManagement nodeId={nodeId} onClickBack={onCancel} onClickInvite={() => setCurrentView('invite')} />
      )}
    </Modal>
  );
};
